import React, { useState } from 'react';
import { Provider } from 'react-redux';
import { Container, Row, Col } from 'react-bootstrap';
import Rodal from 'rodal';
import { ClickAwayListener } from '@material-ui/core';
import { connect } from 'react-redux';

import store from '../redux/store.js';
import '../App.css';
import bliss from '../assets/bliss.jpg';
import landscape from '../assets/landscape.jpg';
import mountains from '../assets/mountains.jpg';
import folder from '../assets/folder.png';
import github from '../assets/github.png';
import linkedin from '../assets/linkedin.png';
import pdf from '../assets/pdf.png';
import cv from '../assets/CV.pdf';
import certificationsFiles from '../utils/certificationsFiles.js';
import educationFiles from '../utils/educationFiles.js';
import experienceFiles from '../utils/experienceFiles.js';
import aboutFiles from '../utils/aboutFiles.js';

import BottomBar from '../components/BottomBar.js';
import Folder from '../components/Folder.js';

import 'rodal/lib/rodal.css';

function Base(props) {
  const [folderName, setFolderName] = useState('');
  const [showFolder, setShowFolder] = useState(false);
  const [hover, setHover] = useState('');
  const [selection, setSelection] = useState('');
  const [items, setItems] = useState([]);

  const handleFolderName = (folderName) => setFolderName(folderName);
  const handleCloseFolder = () => setShowFolder(false);
  const handleShowFolder = () => {
    setShowFolder(true);
    setItems(getFolderItems());
  }

  const setBackgroundColor = (fileName) => {
    if (selection === fileName) {
      return 'rgba(0, 123, 167, 0.5)';
    } else {
      if (hover === fileName) {
        return 'rgba(0, 123, 167, 0.2)';
      } else {
        return 'transparent';
      }
    }
  }

  const getFolderItems = () => {
    switch(selection) {
      case 'Certifications':
        return certificationsFiles;
      case 'Education':
        return educationFiles;
      case 'Experience':
        return experienceFiles;
      case 'About':
        return aboutFiles;
      default:
        return [];
    }
  }

  return (
    <Provider store={store}>
      <img className="Base" src={props.background} alt="background" />
      <Container fluid style={{paddingLeft: '5vw', paddingRight: '5vw', paddingTop: '5vh'}}>
        <Row xs={3} md={3} lg={6}>
          <ClickAwayListener onClickAway={() => selection === 'About' ? setSelection('') : null}>
            <Col onDoubleClick={() => {handleShowFolder(); handleFolderName('About')}} onClick={() => setSelection('About')} onMouseEnter={() => setHover('About')} onMouseLeave={() => setHover('')} style={{backgroundColor: setBackgroundColor('About')}} lg={1}>
              <Row style={{justifyContent: 'center'}}>
                <img src={folder} alt='About' style={{height: '10vh', padding: 10, marginLeft: 10, marginRight: 10}} />
              </Row>
              <Row style={{justifyContent: 'center', textAlign: 'center', color: 'white'}}>
                About
              </Row>
            </Col>
          </ClickAwayListener>
          <ClickAwayListener onClickAway={() => selection === 'LinkedIn' ? setSelection('') : null}>
            <Col onDoubleClick={() => window.open("https://www.linkedin.com/in/joris-truong-35a383131/?locale=en_US", "_blank")} onClick={() => setSelection('LinkedIn')} onMouseEnter={() => setHover('LinkedIn')} onMouseLeave={() => setHover('')} style={{backgroundColor: setBackgroundColor('LinkedIn')}} lg={1}>
              <Row style={{justifyContent: 'center'}}>
                <img src={linkedin} alt='LinkedIn' style={{height: '10vh', padding: 10, marginLeft: 10, marginRight: 10}} />
              </Row>
              <Row style={{justifyContent: 'center', textAlign: 'center', color: 'white'}}>
                LinkedIn
              </Row>
            </Col>
          </ClickAwayListener>
          <ClickAwayListener onClickAway={() => selection === 'Github' ? setSelection('') : null}>
            <Col onDoubleClick={() => window.open("https://github.com/JorisTruong", "_blank")} onClick={() => setSelection('Github')} onMouseEnter={() => setHover('Github')} onMouseLeave={() => setHover('')} style={{backgroundColor: setBackgroundColor('Github')}} lg={1}>
              <Row style={{justifyContent: 'center'}}>
                <img src={github} alt='Github' style={{height: '10vh', padding: 10, marginLeft: 10, marginRight: 10}} />
              </Row>
              <Row style={{justifyContent: 'center', textAlign: 'center', color: 'white'}}>
                Github
              </Row>
            </Col>
          </ClickAwayListener>
        </Row>
      </Container>
      <Container fluid style={{paddingLeft: '5vw', paddingRight: '5vw', paddingTop: '5vh'}}>
        <Row xs={3} md={3} lg={6}>
          <ClickAwayListener onClickAway={() => selection === 'Experience' ? setSelection('') : null}>
            <Col onDoubleClick={() => {handleShowFolder(); handleFolderName('Experience')}} onClick={() => setSelection('Experience')} onMouseEnter={() => setHover('Experience')} onMouseLeave={() => setHover('')} style={{backgroundColor: setBackgroundColor('Experience')}} lg={1}>
              <Row style={{justifyContent: 'center'}}>
                <img src={folder} alt='About' style={{height: '10vh', padding: 10, marginLeft: 10, marginRight: 10}} />
              </Row>
              <Row style={{justifyContent: 'center', textAlign: 'center', color: 'white'}}>
                Experience
              </Row>
            </Col>
          </ClickAwayListener>
          <ClickAwayListener onClickAway={() => selection === 'Certifications' ? setSelection('') : null}>
            <Col onDoubleClick={() => {handleShowFolder(); handleFolderName('Certifications')}} onClick={() => setSelection('Certifications')} onMouseEnter={() => setHover('Certifications')} onMouseLeave={() => setHover('')} style={{backgroundColor: setBackgroundColor('Certifications')}} lg={1}>
              <Row style={{justifyContent: 'center'}}>
                <img src={folder} alt='Certifications' style={{height: '10vh', padding: 10, marginLeft: 10, marginRight: 10}} />
              </Row>
              <Row style={{justifyContent: 'center', textAlign: 'center', color: 'white'}}>
                Certifications
              </Row>
            </Col>
          </ClickAwayListener>
        </Row>
      </Container>
      <Container fluid style={{paddingLeft: '5vw', paddingRight: '5vw', paddingTop: '5vh'}}>
        <Row xs={3} md={3} lg={6}>
          <ClickAwayListener onClickAway={() => selection === 'Education' ? setSelection('') : null}>
            <Col onDoubleClick={() => {handleShowFolder(); handleFolderName('Education')}} onClick={() => setSelection('Education')} onMouseEnter={() => setHover('Education')} onMouseLeave={() => setHover('')} style={{backgroundColor: setBackgroundColor('Education')}} lg={1}>
              <Row style={{justifyContent: 'center'}}>
                <img src={folder} alt='Education' style={{height: '10vh', padding: 10, marginLeft: 10, marginRight: 10}} />
              </Row>
              <Row style={{justifyContent: 'center', textAlign: 'center', color: 'white'}}>
                Education
              </Row>
            </Col>
          </ClickAwayListener>
          <ClickAwayListener onClickAway={() => selection === 'CV' ? setSelection('') : null}>
            <Col onDoubleClick={() => {window.open(cv, "_blank")}} onClick={() => setSelection('CV')} onMouseEnter={() => setHover('CV')} onMouseLeave={() => setHover('')} style={{backgroundColor: setBackgroundColor('CV')}} lg={1}>
              <Row style={{justifyContent: 'center'}}>
                <img src={pdf} alt='CV' style={{height: '10vh', padding: 10, marginLeft: 10, marginRight: 10}} />
              </Row>
              <Row style={{justifyContent: 'center', textAlign: 'center', color: 'white'}}>
                CV
              </Row>
            </Col>
          </ClickAwayListener>
        </Row>
      </Container>

      <Rodal visible={showFolder} onClose={handleCloseFolder} animationType={"zoom"} width={100} height={95} measure={'%'} customStyles={{top: 0, left: 0, margin: 0, padding: 0}} customMaskStyles={{padding: 0}} closeMaskOnClick={false} showMask={false} closeOnEsc={true}>
        <Folder title={folderName} items={items} />
      </Rodal>
      <BottomBar />
    </Provider>
  );
}

function mapStateToProps(state) {
  const background = state.changeBackground.background
  switch(background) {
    case 'bliss':
      return { background: bliss };
    case 'landscape':
      return { background: landscape };
    case 'mountains':
      return { background: mountains };
    default:
      return { background: bliss };
  }
}

export default connect(mapStateToProps, null)(Base);